module.exports = __webpack_public_path__ + "static/media/ptelogo.83ab23c7.png";